import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScheduleService } from 'src/app/core';
import { AttachmentTypeService } from 'src/app/core/services/attachment-type.service';
import { AttachmentType, ScheduleFilesAttachment } from 'src/app/shared/models/schedule.model';

@Component({
  selector: 'app-public-documents',
  templateUrl: './public-documents.component.html',
  styleUrls: ['./public-documents.component.scss']
})
export class PublicDocumentsComponent implements OnInit {

  scheduleId = 0;
  scheduleFilesAttachment: ScheduleFilesAttachment[] = [];
  attachmentTypeList: AttachmentType[] = [];
  attachmentMaster: any[] = [];
  constructor(private route: ActivatedRoute, private scheduleService: ScheduleService, private attachmentTypeService: AttachmentTypeService) { }

  ngOnInit(): void {
    this.loadData();    
  }  

  loadData(): void{
    this.route.queryParams.subscribe(params => {
      this.scheduleId = params['sid'];
      console.log(this.scheduleId);      
    });    

    const attachmentSub = this.scheduleService.getAllFilesAttachments(this.scheduleId).subscribe(res =>{
      if(res.isSuccess){
        this.scheduleFilesAttachment = res.result as ScheduleFilesAttachment[];  
        if (this.scheduleFilesAttachment && this.scheduleFilesAttachment.length > 0) {
          for (let index = 0; index < this.scheduleFilesAttachment.length; index++) {
            if (this.scheduleFilesAttachment[index].filePath.endsWith(".doc") || this.scheduleFilesAttachment[index].filePath.endsWith(".docx")) {
              // this.scheduleFilesAttachment[index].filePath = "https://docs.google.com/gview?url=" + this.scheduleFilesAttachment[index].filePath;
              this.scheduleFilesAttachment[index].filePath = "https://view.officeapps.live.com/op/embed.aspx?src=" + this.scheduleFilesAttachment[index].filePath;
            }
            else if(this.scheduleFilesAttachment[index].filePath.endsWith(".xls")|| this.scheduleFilesAttachment[index].filePath.endsWith(".xlsx")){
              this.scheduleFilesAttachment[index].filePath = "https://view.officeapps.live.com/op/embed.aspx?src=" + this.scheduleFilesAttachment[index].filePath;
            }
            else {
              this.scheduleFilesAttachment[index].filePath = this.scheduleFilesAttachment[index].filePath;
            }
          }
        }
        this.loadAttachmentTypeData();     
      }
    })
  }

  getDownloadPath(viewPath: string){
    if(viewPath.includes('https://view.officeapps.live.com/op/embed.aspx?src=')) viewPath = viewPath.replace('https://view.officeapps.live.com/op/embed.aspx?src=', '');
    return viewPath;
  }

  loadAttachmentTypeData(): void{
    const typeSub = this.attachmentTypeService.getAllActive().subscribe(res =>{
      if(res.isSuccess){
        this.attachmentTypeList = res.result;
        this.attachmentTypeList = this.attachmentTypeList.sort(this.compare_type);
        this.attachmentListSeperator();
        console.log(this.attachmentMaster);
      }
    });

    // this.subscriptions.push(typeSub);
  }
  attachmentListSeperator(): void{    
    var emptyList: ScheduleFilesAttachment[] = [];
    this.attachmentTypeList.forEach(e =>{
      this.attachmentMaster.push({
        title: e.title,
        typeId: e.id,
        data: emptyList
      })
    });
    this.attachmentMaster.push({
      title: 'Tài liệu họp',
      typeId: 0,
      data: this.scheduleFilesAttachment.filter(x => x.attachmentTypeId == 0 || x.attachmentTypeId == null || x.attachmentTypeId == undefined)
    });

    this.attachmentMaster.forEach(e =>{
      if(e.typeId != 0){        
        e.data = this.scheduleFilesAttachment.filter(x => x.attachmentTypeId == e.typeId);
      }
      e.data = e.data.sort(this.compare);
    });    
  }

 compare(a: ScheduleFilesAttachment,b: ScheduleFilesAttachment) {
    if(a.sortOrder > b.sortOrder) return 1;
    else if(a.sortOrder < b.sortOrder) return -1;
    else return 0;
  }

  compare_type(a: AttachmentType, b: AttachmentType){
    if(a.sortOrder > b.sortOrder) return 1;
    else if(a.sortOrder < b.sortOrder) return -1;
    else return 0;
  }

}
